import React from 'react';
import styled from 'styled-components';
import { Reviews } from 'au-gatsby-ds/components';
import { StarProps } from 'components/Yotpo/helpers';
import { mediaQuery, mediaQueryMax } from 'components/Grid';

interface Props {
  stars: React.FunctionComponentElement<StarProps>[];
  totalReviews: number;
  handleClick: React.MouseEventHandler<HTMLAnchorElement>;
}

export const YotpoStarsUI: React.FC<Props> = ({ handleClick, stars, totalReviews }) => (
  <StyledYotpoStars className="yotpo">
    <a href="#yotpo-reviews-anchor" onClick={handleClick}>
      <div className="standalone-bottomline">
        <div className="yotpo-bottomline pull-left star-clickable">
          <span className="yotpo-stars">{stars}</span>
          <span>{totalReviews} Reviews</span>
        </div>
      </div>
    </a>
  </StyledYotpoStars>
);

const StyledYotpoStars = styled.div`
  margin: 12px 0 20px 0;

  ${mediaQuery.medium`
    margin: 0;
  `}
  ${mediaQueryMax.medium`
    margin: 2px 0 20px 0;
  `}
  &.yotpo span {
    ${props => Reviews}
  }

  &.yotpo {
    height: 20px;

    .yotpo-stars {
      margin-right: 4px;
    }

    .yotpo-bottomline {
      .yotpo-icon-star {
        color: #000000;
      }

      .yotpo-icon-half-star:after {
        content: '\\e61a';
        position: absolute;
        left: 0;
        top: 0;
        color: #000000;
        width: 48%;
        overflow: hidden;
      }
    }

    .yotpo-regular-box {
      padding: 0;
      margin: 0;
      border: none;
    }

    .yotpo-small-box,
    .yotpo-first-review,
    .yotpo-review,
    .yotpo-pager {
      display: none;
    }
  }

  .write-review-btn-hidden {
    display: none;
  }
`;
